"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";

export function Layout159() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="flex flex-col items-center">
          <div>
            <img
              src="/images/layouts/ai-second-brain.png"
              className="size-full object-cover"
              alt="Relume placeholder image"
            />
          </div>
          <div className="rb-12 mt-12 md:mt-18 lg:mt-20">
            <div className="text-center">
              <div className="mx-auto flex max-w-lg flex-col items-center justify-start">
                <div className="rb-5 mx-auto mb-5 md:mb-6">
                  <img
                    src="/images/icons/second-brain-icon.png"
                    className="size-20"
                    alt="Relume logo"
                  />
                </div>
                <p className="mb-3 font-semibold md:mb-4">Thinking</p>
                <h2 className="rb-5 mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl">
                  Your ideas stop disappearing
                </h2>
                <p className="md:text-md">
                  Your best thinking lives in conversations—especially AI
                  conversations with ChatGPT, Claude, Gemini, Grok, and
                  Perplexity. IntegrateWise brings those scattered conversations
                  into one searchable Second Brain.
                </p>
                <div className="mt-6 flex flex-wrap items-center justify-center gap-4 md:mt-8">
                  <Button title="Discover" variant="secondary">
                    Discover
                  </Button>
                  <Button
                    title="Arrow"
                    variant="link"
                    size="link"
                    iconRight={<RxChevronRight />}
                  >
                    Arrow
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
